import {Component, DestroyRef, OnInit} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import {CompanyService} from "../../../services/companies-services/company.service";
import {tap} from "rxjs/operators";
import {ApplicationModel} from "../../../models/application.model";
import {LicenseApplicationModel, LicenseCompanyModel} from "../../../models/license.model";
import {LicenseService} from "../../../services/licenses-service/license.service";

@Component({
    selector: 'app-licenses-new-license-dashboard',
    templateUrl: './licenses-new-license-dashboard.component.html',
    styleUrls: ['./licenses-new-license-dashboard.component.scss'],
    standalone: false
})
export class LicensesNewLicenseDashboardComponent implements OnInit {

  companies: LicenseCompanyModel[];

  constructor(
    private licenseService: LicenseService,
    private destroyRef: DestroyRef
  ) { }

  ngOnInit() {
    this.getCompanies();
  }

  public getCompanies() {
    this.licenseService.getCompanies().pipe(
      takeUntilDestroyed(this.destroyRef),
      tap((res: LicenseCompanyModel[]) => this.companies = res)
    ).subscribe();
  }

}
